import { useContext } from "react";
import { CartContext } from "../context/CartContext";
const useCart = () => {
  const {
    cart,
    totalValue,
    dispatch,
    clearCart,
    loadCart,
    finalizeCart,
    loadCartId,
    loadClientCartId,
    setClientCartId,
    cashbackHandler,
    setCartId,
    setCashback,
    orderFinalValue,
    cashback,
    paymentMethod,
    setPaymentMethod,
    paymentMethods,
    isShoppingCenter,
    selectedTargetCompanyId,
    setSelectedTargetCompanyId,
  } = useContext(CartContext);

  return {
    paymentMethod,
    setPaymentMethod,
    orderFinalValue,
    cashback,
    setCashback,
    cart,
    totalValue,
    cashbackHandler,
    dispatch,
    clearCart,
    loadCart,
    finalizeCart,
    loadCartId,
    setCartId,
    paymentMethods,
    setClientCartId,
    loadClientCartId,
    isShoppingCenter,
    selectedTargetCompanyId,
    setSelectedTargetCompanyId,
  };
};
export default useCart;
